// extracted by mini-css-extract-plugin
module.exports = {"subscribeDialogTitle":"SubscribeDialog_subscribeDialogTitle_3_71e","emailInput":"SubscribeDialog_emailInput_2gDRg","primaryButton":"SubscribeDialog_primaryButton_38GmK"};